/**
 * Функция делает следующее:
 * 1. сортирует timestamps по убыванию, таким образом по индексу 0 последняя дата,
 * 2. потом выбираем координаты для этой даты и складываем в массив
 * @param  {string} payloadString // представленный строкой объект приходит как payload в topic,в ней предск callsign, набор координат и еще несколько не нужных.
 * @return {Object<{callsign: number, coordinates: Array<string>}>} // Возвращаем объект с 2 полями
 */
export function formatGeoPosObject(payloadObject) {
  const datesArray = Object.keys(payloadObject.gps_data);
  datesArray.sort((date1, date2) => new Date(date2) - new Date(date1));
  const minDate = datesArray[0];
  const coordinates = [
    payloadObject.gps_data[minDate].lng,
    payloadObject.gps_data[minDate].lat,
  ];
  const { callsign } = payloadObject;

  return { callsign, coordinates };
}

/**
 * Функция принимает тип иконки, вычисляет смещение по оси Y для попапа
 * @param  {string} iconType // Зум карты
 * @return {number} // смещение по оси Y для попапа
 */
export function getYPopupOffset(iconType) {
  switch (iconType) {
    case 'large':
      return -85;
    case 'big':
      return -66;
    case 'normal':
      return -50;
    case 'dot':
      return -40;
    default:
      return -50;
  }
}

/**
 * @param  {string} iconType результат который возвращает функция getIconType вычисляющая тип маркера
 * @return {number} размер шрифта для маркера автомобиля
 */
export function getMarkerFontSize(iconType) {
  switch (iconType) {
    case 'large':
      return 22;
    case 'big':
      return 18;
    case 'normal':
      return 16;
    default:
      return 16;
  }
}

/**
 * @param  {number} zoom
 * @return {'large'|'big'|'normal'|'dot'} возвращет строку с типом иконки
 * расчитывая ее исходя из параметра zoom
 */
export function getIconType(zoom) {
  if (zoom > 17) {
    return 'large';
  }
  if (zoom >= 15 && zoom < 17) {
    return 'big';
  }
  if (zoom > 12 && zoom < 15) {
    return 'normal';
  }
  if (zoom <= 12) {
    return 'dot';
  }
  return 'dot';
}

/**
 * standart: #ffc10e
 * business: #56c4cf
 * premium: #009574
 * busy: #ff547c TODO - ? // Что с этими цветами перекрывать ими?
 * any: #797c7e TODO - ? // какая логика?
 */

/**
 * Возвращет цвет, если в параметрах что то не ожиданное
 * вернет #333 - серый
 * @param  {1|2|3} carClass // число может быть 1 или 2 или 3
 * @return {string} // цвет соответствующий car_class или серый.
 */
export function getColorFromCarClass(carClass) {
  switch (carClass) {
    case 2:
      // standart
      return '#ffc10e';
    case 1:
      // business
      return '#56c4cf';
    case 5:
      // premium
      return '#009574';
    default:
      return '#333';
  }
}

export function getTextOffset(iconType) {
  switch (iconType) {
    case 'large':
      return -45;
    case 'big':
      return -35;
    case 'normal':
      return -28;
    default:
      return 0;
  }
}
